import { LivestreamState, Media } from '#types/generated/graphql-types';

const isNonArchivedLiveStream = (media: Media) => {
  return (
    !!media?.details?.streamState &&
    media.details.streamState !== LivestreamState.Archived
  );
};

export default isNonArchivedLiveStream;
